
export class LoginModel {

    public constructor(init?: Partial<Pick<LoginModel, keyof LoginModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    username: string;
    password: string;

    phoneCountry: string;
    phone: string;

    remember: boolean;
}
